























































import { Vue, Component } from "vue-property-decorator";
import { loadStripe, Stripe, StripeCardElement } from "@stripe/stripe-js";

import { namespace } from "vuex-class";
import { AxiosResponse } from "axios";

const Subscription = namespace("subscriptions");
const Activation = namespace("activation");

@Component({
  components: {},
})
export default class AddCreditCard extends Vue {
  @Activation.Getter("getBillingContactName") billingContactName;
  @Subscription.Action("fetchAllCards")
  fetchAllCards!: () => Promise<AxiosResponse>;
  @Subscription.Action("addCard")
  addCard!: (paymentMethodId: string) => Promise<AxiosResponse>;
  card: StripeCardElement;
  stripe: Stripe;
  loading = false;

  async beforeMount() {
    const { VUE_APP_STRIPE_API, VUE_APP_STRIPE_STAGING_API } = process.env;

    this.stripe = (await loadStripe(
      VUE_APP_STRIPE_API ? VUE_APP_STRIPE_API : VUE_APP_STRIPE_STAGING_API
    )) as Stripe;
    if (this.stripe) {
      const elements = this.stripe.elements();
      // Card Element styles
      const style = {
        base: {
          fontSize: "16px",
          color: "#32325d",
          fontFamily:
            "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
          fontSmoothing: "antialiased",
          "::placeholder": {
            color: "#a0aec0",
          },
        },
      };
      this.card = elements.create("card", { style: style });
      this.card.mount("#card-element");
      this.card.on("focus", function () {
        const el = document.getElementById("card-element-errors");
        if (el) {
          el.classList.add("focused");
        }
      });

      this.card.on("blur", function () {
        const el = document.getElementById("card-element-errors");
        if (el) {
          el.classList.add("focused");
        }
      });

      this.card.on("change", ({ error }) => {
        const displayError = document.getElementById(
          "card-element-errors"
        ) as HTMLElement;
        if (displayError) {
          if (error) {
            displayError.innerHTML = `<b>Error!</b> ${error.message}`;
          } else {
            displayError.innerHTML = "";
          }
        }
      });
    }
  }

  async createPaymentMethod() {
    const card = this.card as StripeCardElement;

    this.loading = true;
    if (this.stripe) {
      this.stripe
        .createPaymentMethod({
          type: "card",
          card: card,
          //eslint-disable-next-line
          billing_details: {
            name: this.billingContactName,
          },
        })
        .then(async (result) => {
          let response;
          if (result.paymentMethod) {
            response = await this.addCard(result.paymentMethod.id);
          }
          if (!result.error) {
            await this.fetchAllCards();
            this.loading = false;
            this.goBack();
            if (response.data) {
              const { last4, brand } = response.data.data;
              this.$notify({
                group: "success",
                title: "Default Card Changed",
                text: `The ${brand} card ending ${last4} was added.`,
              });
            }
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$notify({
            group: "error",
            title: "Failed to add card.",
            text: "Failed to add card.",
          });
        });
    }
  }
  goBack() {
    this.$router.go(-1);
  }
  validations() {
    return {};
  }
}
